<template>
    <section class="survey_section flex">

        <transition name="loading-fade">
            <CandidateSurveyLoading v-if="authStatus == 'loading'" />
        </transition>

        <CandidateTokenError v-if="authStatus == 'error'" />
        <CandidateAlreadyCompleted v-if="authStatus == 'alreadyCompleted'" />
        <CampaignExpired v-if="authStatus == 'campaignClosed'" />

        <CandidateSurvey v-if="authStatus == 'success' && !isCampaign" />
        <CampaignSurvey v-if="authStatus == 'success' && isCampaign" />
        <CandidateResults v-if="authStatus == 'finish'" />


    </section>
</template>

<script>
import CandidateTokenError from "../components/new/candidateTokenError"
import CandidateSurvey from "../components/new/candidateSurvey"
import CandidateSurveyLoading from "../components/new/candidateSurveyLoading"
import CandidateAlreadyCompleted from "../components/new/candidateAlreadyCompleted"
import CandidateResults from "../components/new/candidateResults"

import CampaignSurvey from "../components/new/campaignSurvey"
import CampaignExpired from "../components/new/campaignExpired"

export default {
    name: 'SurveyNew',
    components: {
        CandidateTokenError,
        CandidateSurvey,
        CandidateSurveyLoading,
        CandidateAlreadyCompleted,
        CandidateResults,
        CampaignSurvey,
        CampaignExpired
    },
    data(){
        return {}
    },
    computed: {
        authStatus(){
            return this.$store.state.CandidateStore.status
            // return "loading"
        },
        isCampaign(){
            if(this.$route.query.campaign == "1"){
                return true
            }else{
                return false
            }
        }
    },
    beforeCreate(){
        if(this.$route.query.campaign == "1"){
            this.$store.dispatch('CandidateStore/campaign_login', this.$route.params.evalToken).then((loginData) => {
                if(loginData){
                    this.$i18n.locale = loginData.sight_group.language
                }
            })

        }else{
            this.$store.dispatch('CandidateStore/login', this.$route.params.evalToken).then((loginData) => {
                if(loginData){
                    this.$i18n.locale = loginData.evaluation.language
                }
            })
        }
    },
    methods: {

    }
}

</script>

<style lang="scss">
    .survey_section{
        background: $white;
    }
</style>
